module.exports = __webpack_public_path__ + "static/img/crawlspace_r1_c1.2bfbb1e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/crawlspace_r1_c1.gif
// module id = pA2A
// module chunks = 0